import { render, staticRenderFns } from "./PurchaseReturnListItem.vue?vue&type=template&id=80eeb0c8&"
import script from "./PurchaseReturnListItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseReturnListItem.vue"
export default component.exports